import { render, staticRenderFns } from "./OrgUsers.vue?vue&type=template&id=36e2dfd8&scoped=true&"
import script from "./OrgUsers.vue?vue&type=script&lang=js&"
export * from "./OrgUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2dfd8",
  null
  
)

export default component.exports